__turbopack_context__.v({
  "className": "n7PYBG_className",
  "variable": "n7PYBG_variable",
});
